export const appConfig = {
    REACT_APP_PROXY_BASE_URL: (window as any)._env_.REACT_APP_PROXY_BASE_URL,
    ACTIVATE_CREDIT_CARD: (window as any)._env_.REACT_APP_ACTIVATE_CREDIT_CARD
}